import $ from 'jquery';

var _youtubeVideoContainer = '.js-video';
var _youtubeNoJsLink = '.js-youtube-play';
var _$youtubeNoJsLink = $(_youtubeNoJsLink);
var _youtubePlayers = '.js-youtube-player';
var _$youtubePlayers = $(_youtubePlayers);

var _ytParams = {
    playingClass: 'is-playing'
};

var _ytPlayers = [];

if (_$youtubePlayers.length) {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function _ytPauseAllVideos () {
    for (var p = 0; p < _ytPlayers.length; p++) {
        _ytPlayers[p].pauseVideo();
        _$youtubeNoJsLink.removeClass(_ytParams.playingClass);
        _$youtubeNoJsLink.closest(_youtubeVideoContainer).removeClass(_ytParams.playingCLass);
    }
}

function _ytPlayVideo (i) {
    _$youtubeNoJsLink.eq(i).addClass(_ytParams.playingClass);
    _$youtubeNoJsLink.eq(i).closest(_youtubeVideoContainer).addClass(_ytParams.playingClass);
    _ytPlayers[i].playVideo();
}

window.onYouTubeIframeAPIReady = function () {
    _$youtubePlayers.each(function (i, youtubePlayer) {
        var $youtubePlayer = $(youtubePlayer);

        var params = {};
        var defaults = {
            height: '720',
            width: '1280',
            videoId: $(this).data('video'),
            playerVars: {
                'rel': 0,
                'showinfo': 0,
                'color': 'white'
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        };
        var autoplay = $youtubePlayer.hasClass('autoplay');
        var autoplayOptions = {};

        if (autoplay) {
            autoplayOptions = {
                playerVars: {
                    'autoplay': 1
                }
            };
        }

        params = $.extend(true, defaults, autoplayOptions);

        /**
         * Using `$youtubePlayer` instead of `$(this)[0]`
         * doesn't work.
         */
        var YT = window.YT;
        var player = new YT.Player($(this)[0], params);
        _ytPlayers.push(player);

        function onPlayerReady () {
            var $youtubePlay = $(player.a).closest('.js-youtube-play');
            if (autoplay) {
                player.mute();
                $youtubePlay.addClass(_ytParams.playingClass);
                $youtubePlay.closest(_youtubeVideoContainer).addClass(_ytParams.playingClass);
            }
        }

        function onPlayerStateChange (event) {
            if (event.data === 0) {
                $(event.target.a).closest(_youtubeNoJsLink).removeClass(_ytParams.playingClass);
                $(event.target.a).closest(_youtubeVideoContainer).removeClass(_ytParams.playingClass);
            }
        }
    });

    _$youtubeNoJsLink.on('click', function (e) {
        e.preventDefault();
        var $play = $(this);
        var index = $play.index(_youtubeNoJsLink);
        _ytPauseAllVideos();
        _ytPlayVideo(index);
    });
}
